import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FUNDING_TYPE_OPTIONS } from '../funding-type.constant';

export interface AchUploadDialogResult {
  originatorType: string;
}

@Component({
  selector: 'app-ach-upload-dialog',
  templateUrl: './ach-upload-dialog.component.html',
  styleUrls: ['./ach-upload-dialog.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
  ],
})
export class AchUploadDialogComponent {
  readonly originatorTypes = FUNDING_TYPE_OPTIONS;

  form = new FormGroup({
    originatorType: new FormControl<string>('', [Validators.required]),
  });

  constructor(private readonly dialogRef: MatDialogRef<AchUploadDialogComponent, AchUploadDialogResult>) {}

  onConfirm(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.dialogRef.close({
      originatorType: this.form.value.originatorType!,
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}